import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getDailyView = (params) => {
    return axios.get(`${backendHost}/api/admin/cashiers/shift/daily/view`, {params});
};

export {
    getDailyView
}